import { useEffect, useState } from 'react';

type TimeLeft = { hours: number; minutes: number; seconds: number };

const STORAGE_KEY = 'dopamina-cero-deadline';
const WINDOW_MS = 2 * 60 * 60 * 1000 + 47 * 60 * 1000;

export function useCountdown(): TimeLeft {
  const [deadline] = useState<number>(() => getDeadline());
  const [timeLeft, setTimeLeft] = useState<TimeLeft>(() => compute(deadline));

  useEffect(() => {
    const id = window.setInterval(() => setTimeLeft(compute(deadline)), 1000);
    return () => window.clearInterval(id);
  }, [deadline]);

  return timeLeft;
}

function getDeadline(): number {
  const now = Date.now();
  try {
    const stored = Number(window.localStorage.getItem(STORAGE_KEY));
    if (stored && stored > now) return stored;
    const next = now + WINDOW_MS;
    window.localStorage.setItem(STORAGE_KEY, String(next));
    return next;
  } catch {
    return now + WINDOW_MS;
  }
}

function compute(deadline: number): TimeLeft {
  const diff = Math.max(0, deadline - Date.now());
  return {
    hours: Math.floor(diff / 3_600_000),
    minutes: Math.floor((diff % 3_600_000) / 60_000),
    seconds: Math.floor((diff % 60_000) / 1000),
  };
}
